import moment from 'moment'

export const parseTitle = (title, dayC1, code) => {
  const splitTitle = title ? title.split(' ').filter(i => i) : []
  const newDate = dayC1 ? moment(dayC1).format('DD.MM.YYYY') : ''
  const regexCodes = [
    /^\d\.\d\d?-\d\d\d\d$/,
    /^\d\.\d\d?-\d\d\d\d-\d\d\d\d$/,
    /^\d\.\d\d?-\d\d\d\d-А$/,
    /^\d\.\d\d?-\d\d\d\d-\d\d\d\d-А$/,
    /^\d\.\d\d?-\d\d?$/,
    /^\d\.\d\d?$/
  ]
  if (splitTitle.length) {
    let oldCode
    let oldDate
    const checkCode = regexCodes.some(i => i.test(splitTitle[0]))
    if (checkCode) {
      // eslint-disable-next-line prefer-destructuring
      oldCode = splitTitle[0]
    } else {
      oldDate = moment(splitTitle[0], 'DD.MM.YYYY').isValid()
      const checkCodeAgain = splitTitle[1] ? regexCodes.some(i => i.test(splitTitle[1])) : ''
      if (checkCodeAgain) {
        // eslint-disable-next-line prefer-destructuring
        oldCode = splitTitle[1]
      }
    }

    const startIndex = (oldDate ? 1 : 0) + (oldCode ? 1 : 0)
    return `${newDate} ${code || ''} ${splitTitle.slice(startIndex, splitTitle.length).join(' ')}`
  }

  const newTitle = `${newDate} ${code || ''}`
  return newTitle.trim()
}
